import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">{/*#6372ff 0%, #5ca9fb*/}
      <div className="container">
        <div className="section-title">
          <h2>Servicios</h2>
          <p>
            Tenemos para ti y tus eventos los mejores paquetes de servicios según tus necesidades.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "cargando"}
        </div>
      </div>
    </div>
  );
};
